<template>
  <div
    class="modal fade"
    id="searchBankVeritrans"
    tabindex="-1"
    role="dialog"
    aria-labelledby="searchBankVeritrans"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            {{ $t("bank.account.popup.bank_search") }}
          </h3>
        </div>
        <div class="modal-body">
          <div class="fieldset-cus">
            <form class="form-horizontal">
              <div class="form-group mb-0" style="overflow: auto">
                <label class="col-sm-4 control-label float-left mt-2">
                  {{ $t("bank.account.popup.search_bank_name") }}
                </label>
                <div class="col-sm-8" style="float: left">
                  <div class="input-group">
                    <input type="text" class="form-control input-bank" id="txtBankName" v-model="bankName"/>
                    <div class="input-group-btn">
                      <button id="btn-search" class="btn btn-success btn-bank"
                        @click.prevent="searchBankVeritransPopup()">
                        {{ $t("btn.search") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <table class="table table-striped table-bordered text-center table-hover table-responsive table-bank">
            <thead>
              <tr>
                <th class="text-center text-bank">
                  {{ $t("bank.account.popup.bank_code") }}
                </th>
                <th class="text-center text-bank">
                  {{ $t("bank.account.popup.bank_name") }}
                </th>
                <th class="text-center text-bank">
                  {{ $t("bank.account.popup.selection") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listBank" :key="item.bankCode">
                <td class="align-middle text-bank">{{ item.bankCode }}</td>
                <td class="align-middle text-bank">{{ item.bankName }}</td>
                <td>
                  <button class="btn btn-info btn-bank btn-select"
                    @click="selectBank(item.bankCode, item.bankName, item.bankNameKana)">
                    {{ $t("bank.account.popup.selection") }}
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="3" v-if="infoMessage != null" class="nodata message-bank">
                  {{ $t(infoMessage) }}
                </td>
              </tr>
            </tbody>
          </table>
          <div align="center" v-if="listBank.length >= 0">
            <Pagination
              :total-pages="totalPage"
              :total="totalItems"
              :per-page="offset"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @pageJump="onPageJump"
              :previousText="$t('navigation.bt.previous')"
              :nextText="$t('navigation.bt.next')"
              :firstText="$t('navigation.bt.first')"
              :lastText="$t('navigation.bt.last')"
            ></Pagination>
          </div>
          <p>
            {{ $t("label.deposit.note1") }}
            <a href="https://www.veritrans.co.jp/declaration/BankingAct1.html" target="_blank" style="color: #003eff">https://www.veritrans.co.jp/declaration/BankingAct1.html</a>
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-bank" @click="hideWithConfirm()">
            {{ $t("btn.close_windown") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import Pagination from "@/components/base/Pagination.vue";
import $ from "jquery";

export default {
    name: "SearchBankVeritransModal",
    components: {Pagination},
    data() {
        return {
            listBank: [],
            listBankAfterSearch: [],
            infoMessage: null,
            currentPage: 1,
            model: null,
            bankName: null,
            offset: 10,
            totalPage: 0,
            totalItems: 0,
            isPaginationInBanksSearched: false
        }
    },
    mounted() {
        this.onOpenSearchBankVeritrans();
        this.onCloseConfirmModal();
    },
    methods: {
        show(options) {
            $("#searchBankVeritrans").modal("show");
            this.model = options;
            this.listBank = this.model.listBank;
            this.offset = this.model.pagingInfo.offset;
            this.currentPage = 1;
            this.totalPage = this.getTotalPage(this.offset, this.model.listBank);
            this.listBank = this.getItemsInPage(this.currentPage, this.offset, this.model.listBank);
        },
        getTotalPage(offset, listItem) {
            if (listItem.length === 0) {
                return 1;
            } else {
                return listItem.length % offset === 0 ? listItem.length / offset : parseInt(listItem.length / offset) + 1;
            }
        },
        getItemsInPage(pageNumber, offset, listItem) {
            return listItem.slice((pageNumber - 1) * offset, pageNumber * offset);
        },
        hide() {
            this.closeVeritransModal();
        },
        hideWithConfirm() {
            const params = {messageText: this.$t("MSG_FCM_007")};
            this.$modal.modalConfirm(params, this.IConstants.E_CONFIRM_SCREEN.DEPOSIT_VERITRANS);
        },
        getDataAfterChangePage: function () {
            if (this.bankName && this.bankName != "" && this.isPaginationInBanksSearched) {
                this.listBank = this.getItemsInPage(this.currentPage, this.offset, this.listBankAfterSearch);
                this.totalPage = this.getTotalPage(this.offset, this.listBankAfterSearch);
            } else {
                this.listBank = this.getItemsInPage(this.currentPage, this.offset, this.model.listBank);
                this.totalPage = this.getTotalPage(this.offset, this.model.listBank);
            }
        },
        onPageChange: function (page) {
            this.currentPage = page;
            this.getDataAfterChangePage();
        },
        onPageJump: function (page, previous, next, maxVisibleButtons) {
            this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
            this.getDataAfterChangePage();
        },
        selectBank: function (bankCode, bankName, bankNameKana) {
            const bankInfo = {
                bankCode: bankCode,
                bankName: bankName,
                bankNameKana: bankNameKana,
            };
            this.$modal.emitGetBankInfo(bankInfo);
            this.hide();
        },
        searchBankVeritransPopup: function () {
            let listBank = this.model.listBank;
            this.listBankAfterSearch = [];
            this.currentPage = 1;
            if (this.bankName && this.bankName !== "") {
                this.bankName = this.bankName.trim()
                let bankNameFullsize = this.ServiceUtils.convertHalfToFull(this.bankName);
                let isBankNameContainKanj = this.isContainKanj(bankNameFullsize);
                let bankNameKanaFullsize = "";
                if (!isBankNameContainKanj) {
                    for (let i = 0; i < bankNameFullsize.length; i++) {
                        bankNameKanaFullsize += this.wanakana.toKatakana(bankNameFullsize.charAt(i));
                    }
                }
                listBank.forEach((item) => {
                    let matchBank = false;
                    if (isBankNameContainKanj) {
                        if (item.bankName.includes(bankNameFullsize) || this.ServiceUtils.convertHalfToFull(item.bankName).includes(bankNameFullsize)) {
                            matchBank = true;
                        }
                    } else {
                        if (item.bankName.includes(bankNameFullsize) || item.bankNameKana.includes(bankNameKanaFullsize)) {
                            matchBank = true;
                        }
                    }
                    if (matchBank && this.listBankAfterSearch.indexOf(item) < 0) {
                        this.listBankAfterSearch.push(item);
                    }
                });
                if (this.listBankAfterSearch.length === 0) {
                    this.infoMessage = "nodata.found";
                } else {
                    this.infoMessage = null;
                }
                this.listBank = this.getItemsInPage(1, this.offset, this.listBankAfterSearch);
                this.totalPage = this.getTotalPage(this.offset, this.listBankAfterSearch);
                this.isPaginationInBanksSearched = true;
            } else {
                this.infoMessage = null;
                this.listBank = this.getItemsInPage(1, this.offset, this.model.listBank);
                this.totalPage = this.getTotalPage(this.offset, this.model.listBank);
                this.isPaginationInBanksSearched = false;
            }
        },
        isContainKanj: function (input) {
            for (let i = 0; i < input.length; i++) {
                if (this.isKanji(input.charAt(i))) {
                    return true;
                }
            }
            return false;
        },
        isKanji: function (ch) {
            ch = ch[0];
            return (ch >= '\u4e00' && ch <= '\u9fcf') || (ch >= '\uf900' && ch <= '\ufaff') || (ch >= '\u3400' && ch <= '\u4dbf');
        },
        onOpenSearchBankVeritrans() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SEARCH_BANK_VERITRANS, (options) => {
                $('#searchBankVeritrans').modal({backdrop: 'static', keyboard: false});
                return this.show(options);
            });
        },
        onCloseConfirmModal() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.DEPOSIT_VERITRANS, () => {
                this.closeVeritransModal();
            });
        },
        closeVeritransModal() {
            $("#searchBankId").removeClass("active");
            $("#searchBankVeritrans").modal("hide");
            this.bankName = null; // clear search bank input
        }
    },
};
</script>

<style scoped>
  .table-responsive {
    display: inline-table;
  }
  .modal-dialog {
    max-width: 600px;
  }
  .btn-select {
    width: 54px;
  }
</style>
